import { render, staticRenderFns } from "./RsdProxyCDKey.vue?vue&type=template&id=4f63a86e"
import script from "./RsdProxyCDKey.vue?vue&type=script&lang=js"
export * from "./RsdProxyCDKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports